module.exports = __webpack_public_path__ + "static/media/arrow_left.c2200da0.svg";